module.exports = __webpack_public_path__ + "static/img/home7.64c932ce.jpg";